import React from 'react'
import * as UI from 'ui'
import { Model } from '@morningtrain/react-resources'
import * as Displays from 'support/displays'
import { Translation } from '@morningtrain/react-translations'
import { SelectedDepartmentFilter } from 'support/filters'

export default function CurrentEmploymentsHighligtCard () {
  return (
    <Model resourceName='employments.employment' operationName='current_employments'>
      <SelectedDepartmentFilter />
      <UI.Card>
        <UI.WithSubtitle subtitle={(
          <UI.Text color='primary' uppercase size='xs'>
            <Translation name='partials.current_total_employments' />
          </UI.Text>
        )}
        >
          <UI.Text weight='medium' size='2xl'>
            <Displays.Integer name='employments_count_total' defaultValue={0} />
          </UI.Text>
        </UI.WithSubtitle>
        <UI.HorizontalList className='-mx-8 mt-8 text-center' justify='center' border={false}>
          <UI.DisplayWithTitle flip title={<Translation name='generic.regions.sealand' />}>
            <Displays.Integer name='employments_sealand_count_total' />
          </UI.DisplayWithTitle>
          <UI.DisplayWithTitle flip title={<Translation name='generic.regions.funen' />}>
            <Displays.Integer name='employments_funen_count_total' />
          </UI.DisplayWithTitle>
          <UI.DisplayWithTitle flip title={<Translation name='generic.regions.jutland' />}>
            <Displays.Integer name='employments_jutland_count_total' />
          </UI.DisplayWithTitle>
        </UI.HorizontalList>
      </UI.Card>
    </Model>
  )
}
